import { Box, Button, Dialog, DialogContent, DialogTitle, Divider, Typography } from "@mui/material";
import Grid from "@mui/material/Unstable_Grid2";
import { useEffect, useState } from "react";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faClose } from "@fortawesome/free-solid-svg-icons";
import { LocalizationProvider } from '@mui/x-date-pickers'
import { AdapterDayjs } from '@mui/x-date-pickers/AdapterDayjs'
import { Calendar } from 'react-date-range'
import dayjs, { Dayjs } from "dayjs";
import Swal from "sweetalert2";
import Cookies from "universal-cookie";
import moment from 'moment-timezone';
import { GetProductServiceTimeSlot, GetProductServiceTimeSlotHoliday } from "@/api/product";
import { addDays } from 'date-fns';
import 'react-date-range/dist/styles.css';
import 'react-date-range/dist/theme/default.css';
import { DateRange } from 'react-date-range'

interface Props {
  dataSet: any
}

const DialogCheckDateService: React.FC<Props> = ({ dataSet }) => {

  const cookies = new Cookies();
  const token = cookies.get("token");

  const storeId = dataSet?.store_id || '';
  const productId = dataSet?.product_id || 0;

  const [open, setOpen] = useState(false);
  const [selectedDate, setSelectedDate] = useState<any>(new Date());
  
  const [holiday, setHoliday] = useState<{ day?: number[]; date?: string[] }[]>([]);
  const [dateHoliday, setDateHoliday] = useState<any>([]);

  const [minDate, setMinDate] = useState<Dayjs>(dayjs().add(1, 'day'));

  const [datamindate, setDataMinDate] = useState<any>()
  const [dataExpiredDay, setdataExpiredDay] = useState<any>(new Date())

  const [datacoursetitle, setDataCourseTitle] = useState([])//เอาไว้เก็บค่าcourse_title
  const [dataDateTimeSlot, setDataDateTimeSlot] = useState([])//เก็บค่าของเวลาที่จะเอามาแสดง

  const [checkSelectedDate, setCheckSelectedDate] = useState(false)

  const [disableweekdate, setDisableWeekdate] = useState([])
  const [capacity, setCapacity] = useState<any>()

  const [state, setState] = useState<any[]>([
    {
      startDate: addDays(new Date(), 0),
      endDate: addDays(new Date(), 0),
      key: 'selection',
    },
  ]);

  let minDateValue;
  const datamindateObject = new Date(datamindate);
  if (!(datamindateObject instanceof Date) || isNaN(datamindateObject.getTime())) {
      const tomorrow = new Date();
      tomorrow.setDate(tomorrow.getDate() + 1);
      minDateValue = tomorrow;
  } else {
      minDateValue = datamindateObject;
  }

  let DataExpiredDay = dataExpiredDay;
  let maxDate;

  if (DataExpiredDay !== undefined && DataExpiredDay !== null) {
      maxDate = new Date(DataExpiredDay);
      if (isNaN(maxDate.getTime())) {
          console.error("Invalid date value:", DataExpiredDay);
      }
  } else {
      maxDate = null;
  }

  // Fetch Time Slot
  const fetchGetProductServiceTimeSlot = async (selectedDate: any) => {
    
    const response = await GetProductServiceTimeSlot(token, storeId, productId, moment(selectedDate).format('YYYY-MM-DD'));

    if (response?.success) {
      setDataCourseTitle(response.data.map((dataCourseTitle: any) => {
        return {
          DataCourseTitle: dataCourseTitle.course_title,
          DataCapacity: dataCourseTitle.capacity
        };
      }));
      setDataDateTimeSlot(response.data.map((dataSelectedDate: any) => {
        return {
          DataSelectedStartTime: dataSelectedDate.start_time,
          DataSelectedEndTime: dataSelectedDate.end_time,
          DataCapacity: dataSelectedDate.capacity
        };
      }));
      
      const filteredData = response.data?.filter(
        (item: { capacity: number }) => item.capacity > 0
      );
      const minCapacity = filteredData.length > 0
        ? Math.min(...filteredData.map((item: { capacity: any; }) => item.capacity))
        : 0;

      if (minCapacity !== Infinity) {
        setCapacity(minCapacity);
      }
    }
  };
  

  const fetchGetProductServiceTimeSlotHoliday = async () => {
    const response = await GetProductServiceTimeSlotHoliday(token, storeId, productId);
    if (response.success) {
      setHoliday(response.data);
      setDateHoliday(response?.data)
    }
  };

  // Handle Date Change
  const handleDateChange = (newDateTime: any) => {
    // setCheckSelectedDate(false)
    if (newDateTime) {
      setSelectedDate(newDateTime);
      setCheckSelectedDate(true)
    }
  };

  const handleDateSelection = (ranges: any) => {
    const { startDate, endDate } = ranges.selection;
    setState([ranges.selection]);

    // Calculate days
    const daysCount = dayjs(endDate).diff(dayjs(startDate), 'day') + 1;
    // console.log('Days Count:', daysCount);

    // Send to API
    loopThroughDates(startDate, daysCount);
  };

  const loopThroughDates = async (startDate: Date, daysCount: number) => {
    for (let i = 0; i < daysCount; i++) {
      const date = dayjs(startDate).add(i, 'day').format('YYYY-MM-DD');
      fetchGetProductServiceTimeSlot(date)
    }
  };

  // Check if the day is a weekend or holiday
  const isWeekend = (date: Dayjs) => {
    const day = date.day();
    const weekendDays = holiday[0]?.day || [];
    const holidayDates = dateHoliday[1]?.date || [];
    setDisableWeekdate(dateHoliday[1]?.date)
    return weekendDays.includes(day) || holidayDates.includes(date.format('YYYY-MM-DD'));
  };

  useEffect(() => {
    if (open) {
      // fetchGetProductServiceTimeSlot(selectedDate);
      fetchGetProductServiceTimeSlotHoliday();
      // fetchGetProductServiceTimeSlot(selectedDate)
    }
  }, [open]);

  useEffect(() => {
    if (dataSet?.service_type != "4") {
      fetchGetProductServiceTimeSlot(selectedDate);
    }
  }, [selectedDate]);

  const handleClose = () => {
    setOpen(!open)
    setSelectedDate(new Date())
    setState([
      {
        startDate: addDays(new Date(), 0),
        endDate: addDays(new Date(), 0),
        key: 'selection',
      },
    ])
  }

  return (
    <>
      <Grid xs={12} sx={{ px: "12px" }}>
        <Button
          onClick={handleClose}
          sx={{ p: 1 }}
          variant="outlined"
          fullWidth
          className="btn-10"
        >
					<Typography sx={{ fontSize: 14 }}>ตรวจสอบวันเวลา ที่เปิดบริการ</Typography>
				</Button>
      </Grid>

      <Dialog 
        open={open}
        onClose={handleClose}
        fullWidth={true}
        maxWidth="sm"
      >
        <DialogTitle sx={{ m: 0, pb: 0, textAlign: "end" }} id="customized-dialog-title">
          <FontAwesomeIcon style={{ width: '16px', cursor: "pointer" }} icon={faClose} onClick={() => setOpen(!open)}/>
        </DialogTitle>
        <DialogContent sx={{ p: { xs: 0, lg: "20px 24px" } }}>
          <Grid xs={12} sx={{ textAlign: "center" }}>
            {/* <pre>{JSON.stringify(dataSet?.service_type, null, 2)}</pre> */}
            {dataSet?.service_type == "1" || dataSet?.service_type == "2" ? (
              <Typography className="txt-bold" sx={{ fontSize: "18px", textAlign: "center" }}>
                เลือกวันที่
              </Typography>
            ) : dataSet?.service_type == "3" ? (
              <Typography className="txt-bold" sx={{ fontSize: "18px", textAlign: "center" }}>
                หลักสูตร/คอร์สเรียนที่ให้บริการ
              </Typography>
            ) :  (
              <Typography className="txt-bold" sx={{ fontSize: "18px", textAlign: "center" }}>
                Walk In
              </Typography>
            )}
            {dataSet?.service_type === "1" ? (
              <DateRange
                editableDateInputs={true}
                onChange={handleDateSelection}
                moveRangeOnFirstSelection={false}
                ranges={state}
                minDate={minDateValue}
                disabledDay={(date) => isWeekend(dayjs(date))}
                showDateDisplay={false}
                style={{ width: '100%' }}
              />
            ) : dataSet?.service_type === "2" ? (
              <LocalizationProvider dateAdapter={AdapterDayjs}>
                <Calendar
                  value={selectedDate ? dayjs(selectedDate).toDate() : null}
                  onChange={(e: any) => handleDateChange(e)}
                  disabledDay={(date: any) => isWeekend(dayjs(date))}
                  date={selectedDate}
                  // {...(dataSet?.service_type === "1" && {
                  //   maxDate: dataExpiredDay !== undefined ? new Date(dataExpiredDay) : undefined
                  // })}
                  minDate={minDateValue}
                  sx={{ width: { xs: '100%', md: 'auto' } }}
                />
              </LocalizationProvider>
            ) : ( <></> )}
            {/* <LocalizationProvider dateAdapter={AdapterDayjs}>
              <Calendar
                value={selectedDate ? dayjs(selectedDate).toDate() : null}
                onChange={(e: any) => handleDateChange(e)}
                disabledDay={(date: any) => isWeekend(dayjs(date))}
                date={selectedDate}
                // {...(dataSet?.service_type === "1" && {
                //   maxDate: dataExpiredDay !== undefined ? new Date(dataExpiredDay) : undefined
                // })}
                minDate={minDateValue}
                sx={{ width: { xs: '100%', md: 'auto' } }}
              />
            </LocalizationProvider> */}
          </Grid>
          {/* <Grid xs={12} sx={{ my: 2, px: 2 }}><Divider/></Grid> */}
          {dataSet?.service_type === "1" ? (
            <>
              <Box sx={{ mt: 3, mb: 3, px: 2 }}>
                <Typography sx={{ fontSize: '13px', display: 'flex', alignItems: 'center', color: "#FF0000" }}>
                  {dataExpiredDay !== undefined && dataExpiredDay !== null && !isNaN(Date.parse(dataExpiredDay)) && (
                    <>
                      <Box component="span" sx={{ width: '15px', height: '15px', borderRadius: '50%', backgroundColor: '#D72E2D', marginRight: '8px' }}></Box>
                      <Typography sx={{ fontSize: "13px", pr: .5 }}> voucher นี้ ใช้งานได้ถึงวันที่</Typography>
                      {moment(dataExpiredDay).tz('Asia/Bangkok').format('DD/MM/YYYY')}
                    </>
                  )}
                </Typography>
              </Box>
              <Grid xs={12} sx={{ textAlign: "center" }}>
                <Typography className="txt-bold" sx={{ fontSize: "16px", mb: 1 }}>วันที่ให้บริการ</Typography>
              </Grid>
              <Grid container spacing={2}>
                {dataDateTimeSlot.map((timeSlot: any, index: number) => (
                  <Grid xs={12} key={index} sx={{ textAlign: "center", mb: 2 }}>
                    <div key={timeSlot.DataSelectedEndTime}>
                      <Box>
                        <Typography className="txt-bold" sx={{ fontSize: "14px", display: "inline", pr: 1 }}>
                          {moment(state[0]?.startDate).format('DD/MM/YYYY')} - {moment(state[0]?.endDate).format('DD/MM/YYYY')}
                        </Typography>
                        <Typography
                          sx={{ display: "inline", fontSize: "13px", color: timeSlot.DataCapacity === 0 ? '#D72E2D' : '#717275' }}>
                          ว่าง : {timeSlot.DataCapacity} คิว
                        </Typography>
                      </Box>
                    </div>
                  </Grid>
                ))}
              </Grid>
            </>
          ) : dataSet?.service_type === "2" ? (
            <>
              <Box sx={{ mt: 3, mb: 2, px: 2 }}>
                <Typography sx={{ fontSize: '13px', display: 'flex', alignItems: 'center', color: "#FF0000" }}>
                  {dataExpiredDay !== undefined && dataExpiredDay !== null && !isNaN(Date.parse(dataExpiredDay)) && (
                    <>
                      <Box component="span" sx={{ width: '15px', height: '15px', borderRadius: '50%', backgroundColor: '#D72E2D', marginRight: '8px' }}></Box>
                      <Typography sx={{ fontSize: "13px", pr: .5 }}> voucher นี้ ใช้งานได้ถึงวันที่</Typography>
                      {moment(dataExpiredDay).tz('Asia/Bangkok').format('DD/MM/YYYY')}
                    </>
                  )}
                </Typography>
                <Typography sx={{ fontSize: '13px', display: 'flex', alignItems: 'center', mt: 1 }}>
                  <Box
                    component="span"
                    sx={{ width: '15px', height: '15px', borderRadius: '50%', backgroundColor: '#DEE2E6', marginRight: '8px' }}
                  />
                  วันหยุดร้านค้าและวันหยุดนักขัตฤกษ์
                </Typography>
              </Box>
              {/* <pre>{JSON.stringify(dataDateTimeSlot)}</pre> */}
              <Grid container sx={{ mb: 2, px: 4 }}>
                {dataDateTimeSlot?.length != 0 ? (
                  <>
                    <Grid xs={12} sx={{ textAlign: "center", mt: 2, mb: 1 }}>
                      <Typography className="txt-bold" sx={{ fontSize: "16px" }}>ช่วงเวลาที่เปิดให้บริการ</Typography>
                    </Grid>
                    {dataDateTimeSlot.map((timeSlot: any, index: number) => (
                      <Grid xs={12} sm={6} key={index}>
                        <div key={timeSlot.DataSelectedEndTime}>
                          <Box>
                            <Typography className="txt-bold" sx={{ fontSize: "14px", display: "inline", pr: 1 }}>{timeSlot.DataSelectedStartTime} - {timeSlot.DataSelectedEndTime}</Typography>
                            <Typography
                              sx={{ display: "inline", fontSize: "13px", color: timeSlot.DataCapacity === 0 ? '#D72E2D' : '#717275' }}>
                              จำนวนคิวที่เหลือ : {timeSlot.DataCapacity} คิว
                            </Typography>
                          </Box>
                        </div>
                      </Grid>
                    ))}
                  </>
                ) : (
                  <Grid xs={12}>
                    <Typography sx={{ textAlign: "center", color: "#717275", fontSize: "13px" }}>ไม่พบช่วงเวลาที่เปิดให้บริการ</Typography>
                  </Grid>
                )}
              </Grid>
            </>
          ) : dataSet?.service_type === "3" ? (
            <Grid container sx={{ mt: 2, mb: 2, px: 4 }}>
              {datacoursetitle.map((item: any, index: number) => (
                <Grid xs={12} key={index} sx={{ py: .5 }}>
                  <div key={index}>
                    <Box>
                      <Typography className="txt-bold" sx={{ fontSize: "14px", display: "inline", pr: 1 }}>
                        {item.DataCourseTitle}
                      </Typography>
                      <Typography sx={{ display: "inline", fontSize: "13px" }}>
                        จำนวนคิวที่เหลือ : {item.DataCapacity} คิว
                      </Typography>
                    </Box>
                  </div>
                </Grid>
              ))}
            </Grid>
          ) : dataSet?.service_type === "4" ? (
            <Grid xs={12} sx={{ mt: 2, mb: 2, textAlign: "center" }}>
              <Typography className="txt-bold" sx={{ fontSize: "16px" }}>
                คุณสามารถเข้ารับบริการนี้ได้ทันที
              </Typography>
              <Typography className="" sx={{ fontSize: "15px" }}>
                หรือสอบถามรายละเอียดกับทางร้าน เพื่อความสะดวกในการเข้ารับบริการ
              </Typography>
            </Grid>
          ) : (
            <Grid xs={12} sx={{ mt: 2, textAlign: "center" }}><Typography className="txt-bold" sx={{ fontSize: "16px", mb: 3 }}>ไม่พบช่วงเวลาที่เปิดให้บริการ</Typography></Grid>
          )}




          <Grid xs={12} sx={{ mt: 2, mb: 2, px: 2 }}><Divider/></Grid>
          <Grid xs={12}>
            <Typography sx={{ fontSize: "13px", color: "#FF0000", mb: 3, textAlign: "center" }}> 
              สำหรับตรวจสอบจำนวนคิวที่เหลืออยู่เท่านั้น ไม่เกี่ยวข้องกับการซื้อหรือการจองนัดหมาย
            </Typography>
          </Grid>
          {/* <Grid xs={12} md={5} sm={5} xl={5} lg={5} sx={{ mb: 3 }}>
            {checkSelectedDate && selectedDate && dataDateTimeSlot && dataDateTimeSlot.length > 0 ? (
              <>
                <Grid xs={12} sx={{ textAlign: "center" }}><Typography className="txt-bold" sx={{ fontSize: "16px", mb: 1 }}>ช่วงเวลาที่เปิดให้บริการ</Typography></Grid>
                <Grid container spacing={2}>
                  {dataDateTimeSlot.map((timeSlot: any, index: number) => (
                    <Grid xs={6} key={index}>
                      <div key={timeSlot.DataSelectedEndTime}>
                        <Box>
                          <Typography className="txt-bold" sx={{ fontSize: "14px", display: "inline", pr: 1 }}>{timeSlot.DataSelectedStartTime} - {timeSlot.DataSelectedEndTime}</Typography>
                          <Typography
                            sx={{ display: "inline", fontSize: "13px", color: timeSlot.DataCapacity === 0 ? '#D72E2D' : '#717275' }}>
                            จำนวนคิวที่เหลือ : {timeSlot.DataCapacity} คิว
                          </Typography>
                        </Box>
                      </div>
                    </Grid>
                  ))}
                </Grid>
              </>
            ) : (
              <Grid xs={12} sx={{ mt: 2, textAlign: "center" }}><Typography className="txt-bold" sx={{ fontSize: "16px", mb: 1 }}>ไม่พบช่วงเวลาที่เปิดให้บริการ</Typography></Grid>
            )}
          </Grid> */}
        </DialogContent>
      </Dialog>
    </>
  )
}

export default DialogCheckDateService;